import clientSay1 from "images/clientSay1.png";
import clientSay4 from "images/clientSay2.png";
import clientSay5 from "images/clientSay3.png";

export const globalJson = {
  prod_company_id: 236,
  dev_company_id: 236,

  // apiUtil auth header key
  authToken: "Bearer 168|3oLFn8OniSxk1UBTO3eQeGXMuViDTsZqAwhalwWm",
  companyId: "7514a219-48ce-439e-a2c5-6f38980cee1a",
  stripePublishableKey:
    "pk_live_51LdnoABqYa4ICTHoC6CjEgImHYOvUXXPs8psg8jZqXPxRwBt99nQEWtFFJj2n3ublkCJa0S8pYzDtvStF2JxUPzU00uWCskvlb",
  mapKey: "AIzaSyDKEntg7JydrxI7zr2tQL5OYcS5M-er-bc",
  residenceStateCode: "AZ",

  //email confirmation admin token
  adminEmailToken:
    "XR85jFku2zMMqvsYmAdkrk1lm6pozj7eFXetRHLNSSsLxRLnAHgY3dPaVsE27OK8cIbnhFQmncWxVjS1XLAhneFEFpwVVeaNE7hMOym2vrhzdKSmxn99V0fLvVJyZLPT",
  websiteLink: "https://Supre Auto Group-dev.1now.app",
  sender: "Supre Auto Group",
  ccEmail: "Supre Auto Group@gmail.com",

  // apiUtil sendNewsLetterEmail
  util_serviceId: "service_2xca7kj",
  util_templateId: "template_smckeo7",
  util_userId: "ATdsFr5wumje11YkV",
  util_privateKey: "TJyyV_e7nNOGPKbyyjpMB",
  util_contact_templateId: "template_9dsuz0w",

  // apiUtil getBonzahToken
  client_secret_dev: "",
  client_id_dev: "",
  client_secret_prod: "",
  client_id_prod: "",

  about_us_para:
    "Supre Auto Group Group is a premier Exotic & Luxury Transportation Consultant, providing high-end vehicle concierge services, including exclusive rentals and chauffeur-driven experiences. Based in the Washington, D.C. Metropolitan area, we specialize in curating bespoke transportation solutions for discerning clients. Whether you need a luxury vehicle for a special occasion, a seamless executive travel experience, or expert guidance in selecting the perfect exotic car, we deliver exceptional service with professionalism and discretion. At Supre Auto Group Group, we go beyond rentals—we offer a full luxury mobility experience tailored to your lifestyle",

    clientSays_arr: [
      {
        id: 1,
        clientName: "John D.",
        clientAddress: "Dodge Grand Caravan 2019",
        content:
          "The service was excellent, and the car was in top-notch condition. I'll definitely rent from here again!",
        img: clientSay1,
      },
      {
        id: 2,
        clientName: "Samantha L.",
        clientAddress: "LondDodge Grand Caravan 2019",
        content:
          "The process was so smooth, and I appreciated the friendly staff. Highly recommend this company for car rentals!",
        img: clientSay4,
      },
      {
        id: 3,
        clientName: "Michael R.",
        clientAddress: "Dodge Grand Caravan 2019",
        content:
          "The car was clean, affordable, and reliable. I had a great experience and will use them again for my next trip!",
        img: clientSay5,
      },
    ],

  //social links
  facebook:
    "https://www.facebook.com/",
  instagram:
    "https://www.instagram.com/",

  //contact
  address: "2800 Eisenhower Avenue #220 Alexandria, VA 22314",
  addressLink:
    "https://www.google.com/maps/place/4830+W+Kennedy+Blvd,+Tampa,+FL+33609,+USA/data=!4m2!3m1!1s0x88c2c2e4b61fbe87:0x7fa31f86943d0895?sa=X&ved=1t:242&ictx=111",
  phone: "866-815-0518", //pending
  email: "Support@supreautogroup.com", //pending
};

export const scriptHubSpot = document.createElement("script");
scriptHubSpot.src = "//js-na1.hs-scripts.com/46776911.js";
scriptHubSpot.async = true;
scriptHubSpot.defer = true;
scriptHubSpot.id = "hs-script-loader";
